import React from 'react';
import { ButtonUI, Wrapper } from './styled';
import { IButtonQuestionProps } from '../../../types';

export const ButtonQuestion = ({ hasQuestions, productId }: IButtonQuestionProps) => {
  if (!hasQuestions) {
    return <></>;
  }

  return (
    <Wrapper>
      <ButtonUI
        href={`/perguntar/${productId}`}
        width="200px"
        height="45px"
        title="Fazer pergunta"
        borderRadius="8px"
        fontSize="16px"
      />
    </Wrapper>
  );
};

export default ButtonQuestion;
